const mediaTypeField = {
  type: "string",
  label: "Media Type",
  name: "mediaType",
  description: "Choose between image or YouTube video",
  options: ["image", "youtube"],
};

export default mediaTypeField;
